<div>
    <ng-multiselect-dropdown 
    [disabled]="isReadonly" 
    [placeholder]="placeholder" 
    [settings]="dropdownSettings" 
    [data]="optionSetList" 
    [(ngModel)]="selectedItems" 
    (onSelect)="onItemSelect($event)" 
    (onDeSelect)="onItemDeSelect($event)" 
    (onSelectAll)="onSelectAll($event)" 
    (onDeSelectAll) = "onSelectAll($event)"
    [settings]="boolean == true? booleanDropdownSettings : dropdownSettings">
    </ng-multiselect-dropdown>
    <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="search"></mat-icon>
</div>